import React from 'react';

import { FaAngleDown } from 'react-icons/fa';
import styled from 'styled-components';

import { Flyout } from '@techstyle/react-components-legacy';

const StyledFlyout = styled(Flyout)`
  width: 100%;
  ${Flyout.Popup} {
    top: calc(100%);
    left: 0;
    transform: translateX(0);
    margin: 0;
    background: ${props => props.theme.colors.white};
    border: 1px solid ${props => props.theme.colors.gray250};
    padding: 11px;
    box-shadow: 0 2px 4px 0 ${({ theme }) => theme.colors.lightShadow3};
    border-radius: 4px;
  }
  ${Flyout.Popup}:focus {
    outline: none;
  }
`;

const ChevronDown = styled(FaAngleDown).attrs({
  role: 'presentation',
  size: 9,
})`
  transition: transform 150ms ease;
  margin-top: 2px;
`;

const Button = styled.button`
  display: flex;
  align-items: center;
  border-radius: 2px;
  padding: ${props => props.theme.spacing.tiny}px;
  &[aria-expanded='true'] {
    color: ${props => props.theme.colors.white};
    background-color: ${props => props.theme.colors.active};
    ${ChevronDown} {
      transform: rotate(180deg);
    }
  }
`;

const FilterFlyout = ({ children, className, label }) => (
  <StyledFlyout
    className={className}
    toggleButton={
      <Button>
        {label}
        <ChevronDown />
      </Button>
    }
  >
    {children}
  </StyledFlyout>
);

FilterFlyout.Popup = Flyout.Popup;
FilterFlyout.Button = Button;

export default FilterFlyout;
